import { makeStyles } from 'tss-react/mui';

export const useCatalogCardActionsStyles = makeStyles()({
  iconButton: {
    width: '24px',
    height: '24px',
    padding: '4px',
  },
});
